export default __webpack_public_path__ + "static/media/2017.6664a4b9.png";